import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'tr',
  Pagination: {
    items_per_page: '/ sayfa',
    jump_to: 'Git',
    jump_to_confirm: 'onayla',
    page: '',
    prev_page: 'Önceki Sayfa',
    next_page: 'Sonraki Sayfa',
    prev_5: 'Önceki 5 Sayfa',
    next_5: 'Sonraki 5 Sayfa',
    prev_3: 'Önceki 3 Sayfa',
    next_3: 'Sonraki 3 Sayfa',
  },
  DatePicker: {
    lang: {
      placeholder: 'Tarih seç',
      yearPlaceholder: 'Yıl seç',
      quarterPlaceholder: 'Çeyrek seç',
      monthPlaceholder: 'Ay seç',
      weekPlaceholder: 'Hafta seç',
      rangePlaceholder: [
        'Başlangıç tarihi',
        'Bitiş tarihi',
      ],
      rangeYearPlaceholder: [
        'Başlangıç yılı',
        'Bitiş yılı',
      ],
      rangeMonthPlaceholder: [
        'Başlangıç ayı',
        'Bitiş ayı',
      ],
      rangeWeekPlaceholder: [
        'Başlangıç haftası',
        'Bitiş haftası',
      ],
      locale: 'tr_TR',
      today: 'Bugün',
      now: 'Şimdi',
      backToToday: 'Bugüne Geri Dön',
      ok: 'tamam',
      clear: 'Temizle',
      month: 'Ay',
      year: 'Yıl',
      timeSelect: 'Zaman Seç',
      dateSelect: 'Tarih Seç',
      monthSelect: 'Ay Seç',
      yearSelect: 'Yıl Seç',
      decadeSelect: 'On Yıl Seç',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Önceki Ay (PageUp)',
      nextMonth: 'Sonraki Ay (PageDown)',
      previousYear: 'Önceki Yıl (Control + Sol)',
      nextYear: 'Sonraki Yıl (Control + Sağ)',
      previousDecade: 'Önceki On Yıl',
      nextDecade: 'Sonraki On Yıl',
      previousCentury: 'Önceki Yüzyıl',
      nextCentury: 'Sonraki Yüzyıl',
    },
    timePickerLocale: {
      placeholder: 'Zaman seç',
      rangePlaceholder: [
        'Başlangıç zamanı',
        'Bitiş zamanı',
      ],
    },
  },
  TimePicker: {
    placeholder: 'Zaman seç',
    rangePlaceholder: [
      'Başlangıç zamanı',
      'Bitiş zamanı',
    ],
  },
  Calendar: {
    lang: {
      placeholder: 'Tarih seç',
      yearPlaceholder: 'Yıl seç',
      quarterPlaceholder: 'Çeyrek seç',
      monthPlaceholder: 'Ay seç',
      weekPlaceholder: 'Hafta seç',
      rangePlaceholder: [
        'Başlangıç tarihi',
        'Bitiş tarihi',
      ],
      rangeYearPlaceholder: [
        'Başlangıç yılı',
        'Bitiş yılı',
      ],
      rangeMonthPlaceholder: [
        'Başlangıç ayı',
        'Bitiş ayı',
      ],
      rangeWeekPlaceholder: [
        'Başlangıç haftası',
        'Bitiş haftası',
      ],
      locale: 'tr_TR',
      today: 'Bugün',
      now: 'Şimdi',
      backToToday: 'Bugüne Geri Dön',
      ok: 'tamam',
      clear: 'Temizle',
      month: 'Ay',
      year: 'Yıl',
      timeSelect: 'Zaman Seç',
      dateSelect: 'Tarih Seç',
      monthSelect: 'Ay Seç',
      yearSelect: 'Yıl Seç',
      decadeSelect: 'On Yıl Seç',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Önceki Ay (PageUp)',
      nextMonth: 'Sonraki Ay (PageDown)',
      previousYear: 'Önceki Yıl (Control + Sol)',
      nextYear: 'Sonraki Yıl (Control + Sağ)',
      previousDecade: 'Önceki On Yıl',
      nextDecade: 'Sonraki On Yıl',
      previousCentury: 'Önceki Yüzyıl',
      nextCentury: 'Sonraki Yüzyıl',
    },
    timePickerLocale: {
      placeholder: 'Zaman seç',
      rangePlaceholder: [
        'Başlangıç zamanı',
        'Bitiş zamanı',
      ],
    },
  },
  global: {
    placeholder: 'Lütfen seçiniz',
  },
  Table: {
    filterTitle: 'Filtre menüsü',
    filterConfirm: 'Tamam',
    filterReset: 'Sıfırla',
    filterEmptyText: 'Filtre yok',
    selectAll: 'Tüm sayfayı seç',
    selectInvert: 'Tersini seç',
    selectionAll: 'Tümünü seç',
    sortTitle: 'Sırala',
    expand: 'Satırı genişlet',
    collapse: 'Satırı daralt',
    triggerDesc: 'Azalan düzende sırala',
    triggerAsc: 'Artan düzende sırala',
    cancelSort: 'Sıralamayı kaldır',
  },
  Modal: {
    okText: 'Tamam',
    cancelText: 'İptal',
    justOkText: 'Tamam',
  },
  Popconfirm: {
    okText: 'Tamam',
    cancelText: 'İptal',
  },
  Transfer: {
    titles: [
      '',
      '',
    ],
    searchPlaceholder: 'Arama',
    itemUnit: 'Öğe',
    itemsUnit: 'Öğeler',
    remove: 'Kaldır',
    selectCurrent: 'Tüm sayfayı seç',
    removeCurrent: 'Sayfayı kaldır',
    selectAll: 'Tümünü seç',
    removeAll: 'Tümünü kaldır',
    selectInvert: 'Tersini seç',
  },
  Upload: {
    uploading: 'Yükleniyor...',
    removeFile: 'Dosyayı kaldır',
    uploadError: 'Yükleme hatası',
    previewFile: 'Dosyayı önizle',
    downloadFile: 'Dosyayı indir',
  },
  Empty: {
    description: 'Veri Yok',
  },
  Icon: {
    icon: 'ikon',
  },
  Text: {
    edit: 'Düzenle',
    copy: 'Kopyala',
    copied: 'Kopyalandı',
    expand: 'Genişlet',
  },
  PageHeader: {
    back: 'Geri',
  },
  Form: {
    optional: '(opsiyonel)',
    defaultValidateMessages: {
      default: 'Alan doğrulama hatası ${label}',
      required: '${label} gerekli bir alan',
      enum: '${label} şunlardan biri olmalı: [${enum}]',
      whitespace: '${label} sadece boşluk olamaz',
      date: {
        format: '${label} tarih biçimi geçersiz',
        parse: '${label} bir tarihe dönüştürülemedi',
        invalid: '${label} geçersiz bir tarih',
      },
      types: {
        string: '${label} geçerli bir ${type} değil',
        method: '${label} geçerli bir ${type} değil',
        array: '${label} geçerli bir ${type} değil',
        object: '${label} geçerli bir ${type} değil',
        number: '${label} geçerli bir ${type} değil',
        date: '${label} geçerli bir ${type} değil',
        boolean: '${label} geçerli bir ${type} değil',
        integer: '${label} geçerli bir ${type} değil',
        float: '${label} geçerli bir ${type} değil',
        regexp: '${label} geçerli bir ${type} değil',
        email: '${label} geçerli bir ${type} değil',
        url: '${label} geçerli bir ${type} değil',
        hex: '${label} geçerli bir ${type} değil',
      },
      string: {
        len: '${label} ${len} karakter olmalı',
        min: '${label} en az ${min} karakter olmalı',
        max: '${label} en çok ${max} karakter olmalı',
        range: '${label} ${min}-${max} karakter arası olmalı',
      },
      number: {
        len: '${label} ${len} olmalı',
        min: '${label} en az ${min} olmalı',
        max: '${label} en çok ${max} olmalı',
        range: '${label} ${min}-${max} arası olmalı',
      },
      array: {
        len: '${label} sayısı ${len} olmalı',
        min: '${label} sayısı en az ${min} olmalı',
        max: '${label} sayısı en çok ${max} olmalı',
        range: '${label} sayısı ${min}-${max} arası olmalı',
      },
      pattern: {
        mismatch: '${label} şu kalıpla eşleşmeli: ${pattern}',
      },
    },
  },
  Image: {
    preview: 'Önizleme',
  },
};

export default localeValues;
